// Empleados que no checan: no deben aparecer en faltas, asistencias,
// calendario general ni reportes generados a partir del checador.
export const IDS_EMPLEADOS_SIN_CHECADOR = [
    "60a86d7f-17d5-4e10-80ee-08f6b194f17c", // Alan Uriel Olvera
    "6aa0f2ea-f949-4bf0-a3cb-bcf3fe301b06", // juan prueba prueba (#1002)
];

export const empleadoSinChecador = (idEmpleado) =>
    IDS_EMPLEADOS_SIN_CHECADOR.includes(idEmpleado);
